import { render } from "./levels.vue?vue&type=template&id=33dd6f8c&scoped=true"
import script from "./levels.vue?vue&type=script&lang=js"
export * from "./levels.vue?vue&type=script&lang=js"

import "./levels.vue?vue&type=style&index=0&id=33dd6f8c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33dd6f8c"]])

export default __exports__